import React from 'react'
import { action } from '@storybook/addon-actions'
import { storiesOf } from '@storybook/react'
import { withKnobs, button } from '@storybook/addon-knobs/react'

import { MatchEventType, IMatchEvent, IClock, IPlayer, IMatch } from 'protos'

import Timeline from 'components/Timeline'

interface TimelineStoryProps {
}

type TimelineStoryState = {
  events: IMatchEvent[],
  clock: IClock,
}

class TimelineStory extends React.Component<TimelineStoryProps, TimelineStoryState> {
  constructor(props: TimelineStoryProps) {
    super(props)

    this.state = {
      events: [{
        type: MatchEventType.ET_ADM_MATCH_STARTED,
        eventId: '1',
        timestamp: Math.round(Date.now() / 1000),
      }],
      clock: { minute: 1 },
    }
  }

  addMatchEvent = (count: number = 1) => {
    let events: IMatchEvent[] = this.state.events

    for (let i = 0; i < count; i++) {
      const newEvent: IMatchEvent = {
        eventId: Math.round(Math.random() * 1000000).toString(),
        playerId: i % 2 ? '1' : '2',
        teamId: i % 2 ? 'home' : 'away',
        displayValue: i % 2 ? -2 : 5,
        type: i % 2 ? MatchEventType.ET_YELLOW_CARD : MatchEventType.ET_SHOT_ON_GOAL,
        clock: this.state.clock,
      }

      events = [ ...events, newEvent ]
    }

    const { minute, extra } = this.state.clock
    const clock: IClock = {
      minute: minute! < 90 ? minute! + 1 : minute,
      extra: minute! < 90 ? extra : (extra || 0) + 1,
    }

    this.setState({ ...this.state, events, clock })
  }

  get players(): { [k: string]: IPlayer } {
    return {
      '1': {
        playerId: '1',
        name: 'K. Waldo',
        team: {
          teamId: 'home',
        },
        jersey: {
          jerseyNumber: '7',
          baseColor: '9009a5',
          sleeveColor: '06109e',
          numberColor: 'ffffff',
        },
      },
      '2': {
        playerId: '2',
        name: 'T. Mecdermond',
        team: {
          teamId: 'away',
        },
        jersey: {
          jerseyNumber: '12',
          baseColor: '4cf939',
          sleeveColor: '69cc00',
          numberColor: '000000',
        },
      },
    }
  }

  get match(): IMatch {
    return {
      homeTeam: {
        teamId: 'home',
        jersey: {
          baseColor: '9009a5',
          sleeveColor: '06109e',
          numberColor: 'ffffff',
        },
      },
      awayTeam: {
        teamId: 'away',
        jersey: {
          baseColor: '4cf939',
          sleeveColor: '69cc00',
          numberColor: '000000',
        },
      },
    }
  }

  renderButtons = () => {
    button('Add 1 MatchEvent', () => this.addMatchEvent(1))
    button('Add 3 MatchEvent', () => this.addMatchEvent(3))
  }

  render() {
    this.renderButtons()

    return (
      <Timeline
        match={this.match}
        events={this.state.events}
        players={this.players}
        onClickEvent={action('onClickEvent')}
      />
    )
  }
}

storiesOf('Timeline', module)
  .addDecorator(withKnobs)
  .addDecorator((story) => (
    <div style={{ padding: 16 }}>{story()}</div>
  ))
  .add('default', () => <TimelineStory />)
